import { create } from '@/store/store'
import { devtools } from 'zustand/middleware'

interface NotificationsStore {
  isNewExists: boolean;
  setIsNewExists: (isNewExists: boolean) => void;
}

export const useNotificationsStore = create<NotificationsStore>()(
  devtools(
    (set) => ({
      isNewExists: false,
      setIsNewExists: (isNewExists: any) => set(() => ({ isNewExists }), false, 'setIsNewExists'),
    }),
    {
      name: 'useNotificationsStore',
    },
  ),
)
